
export default host => ({ client, startDate, endDate }) =>
  `${host}/contentCreators/exportByDate?${client ? `client_id=${client}&` : ""}${startDate && endDate ? `date_start=${startDate}&date_end=${endDate}` : ""}`

